import React, { Component } from "react"

export default class FlightsLoading extends Component {
  render() {
    return (
      <React.Fragment>
        <section className="deck deck--margin-bottom deck-flights">
          <div className="flights" id="FlightSection">
            <div id="previousFlightsTable">
              <div className="flights__table--wrapper">
                <div className="flights__table stylish-table no-flights">
                  <div className="w--wider">
                    <div className="stylish-table__row stylish-table__row--head">
                      <button className="previous-flight-link"></button>
                      <div className="date"></div>
                    </div>
                    <div className="inner-previous-flights" />
                  </div>
                </div>
              </div>
            </div>
            <div className="flights__table stylish-table js--stylish-table" id="flightFirstTable">
              <div className="w--wider">
                <div className="">
                  <div className="previous-flights-rotator">
                    {[...Array(10)].map((el, index) => (
                      <a key={index} className="stylish-table__row stylish-table__row--body pointer flight-row" data-date="20. juni" href="">
                        <div className="stylish-table__cell flights__table__col--time">
                          <div>
                            <span className="t--strike"></span>
                            <span>
                              <em>&nbsp;</em>
                            </span>
                          </div>
                        </div>
                        <div className="stylish-table__cell flights__table__col--destination">
                          <div>
                            <span className="v--desktop-only">
                              <strong>
                                <span>&nbsp;</span>
                              </strong>
                            </span>
                            <span className="v--mobile-only">
                              <strong>&nbsp;</strong>
                            </span>
                            <span className="v--mobile-only">&nbsp;</span>
                          </div>
                        </div>
                        <div className="stylish-table__cell  flights__table__col--link">
                          <div>
                            <div></div>
                            <button className="infoarrow">&nbsp;</button>
                          </div>
                        </div>
                      </a>
                    ))}
                  </div>
                </div>
              </div>
              <div className="buttoncontainer has-button">
                <a className="button button--expander">
                  <span className="text">&nbsp;</span>
                </a>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    )
  }
}
